import { createSlice } from '@reduxjs/toolkit';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { SoundTracksManagement } from '../Api/SoundTracksManagement';


export const fetchSoundTracksThunk = createAsyncThunk(
    'soundTracks/fetch',
    async (_, { getState }) => {
        try {
            const { api_token } = getState().profile.data;
            const response = await SoundTracksManagement.fetch({ api_token });
            return response.data
        } catch (err) {
            return Promise.reject(err);
        }
    }
)

export const deleteSoundTracksThunk = createAsyncThunk(
    'soundTracks/delete',
    async ({ audio_slug, setSoundTrackList }, { dispatch, getState }) => {
        try {
            const { api_token } = getState().profile.data;
            const response = await SoundTracksManagement.delete({ audio_slug, api_token });
            setSoundTrackList(prev => {
                return [
                    ...prev.map(tracks => {
                        if (tracks.audio_slug != audio_slug)
                            return {
                                ...tracks
                            };
                    })
                ].filter(Boolean);
            }
            )
            dispatch(removeSoundTrack({ audio_slug }));
            return response.data
        } catch (err) {
        }
    }
)


const initialState = {
    status: "pending",
    data: [],
}

export const soundTracksSlice = createSlice({
    name: 'soundTracks',
    initialState,
    reducers: {
        setStatus: (state, actions) => {
            return {
                ...state,
                ...actions.payload
            }
        },
        resetState: () => {
            return initialState
        },
        removeSoundTrack: (state, actions) => {
            const list = {
                ...state,
                data: [...state.data.map(item => {
                    return {
                        ...item,
                        track_list: [...item.track_list.map(tracks => {
                            if (tracks.audio_slug != actions.payload.audio_slug)
                                return {
                                    ...tracks
                                };
                        })].filter(Boolean)
                    }


                })]
            }
            return list;

        }
    },
    extraReducers: {
        [fetchSoundTracksThunk.fulfilled]: (state, action) => {
            state.data = action.payload
            state.status = "success"
        },
        [fetchSoundTracksThunk.pending]: (state, action) => {
            state.status = "loading"
        },
        [deleteSoundTracksThunk.fulfilled]: (state, action) => {
            state.status = "success"
        },
        [deleteSoundTracksThunk.pending]: (state, action) => {
            state.status = "success"
        },
        [deleteSoundTracksThunk.error]: (state, action) => {
            state.status = "error"
        },
    }
})


// Action creators are generated for each case reducer function
export const { setStatus, removeSoundTrack,resetState } = soundTracksSlice.actions

export default soundTracksSlice.reducer